var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com1",class:{'bor':_vm.bor===true}},[_c('div',[_vm._v("\n        我是组件1\n    ")]),_c('div',{staticClass:"closeIcon icon"},[_vm._v("x")])])}
var staticRenderFns = []

export { render, staticRenderFns }